import styled from 'styled-components';
import { useSelector } from 'src/store/store';
import i18n from 'src/utils/translate';
import membersFilterOptions from 'src/constants/membersFilterOptions';
import { redirectToMembersPage } from 'src/utils/router';
import PostFilterInline from 'src/components/postFilterInline';
import CommunityCardLoader from 'src/modules/search/communities/components/communityCardLoader';
import SearchBar from 'src/modules/search/shared/components/searchBar';
import PrivatePageErrorMessage from 'src/components/privatePageErrorMessage';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { titleSmall } from 'styles-js/mixins/typography';
import MembersList from 'src/modules/community/communityMembers/communityMembersList';
import { useBranch } from 'src/utils/cookie';
import { useMediaQuery } from 'src/utils/mediaQuery';

export default function CommunityMembersContent() {
  const { slug: communitySlug, name: communityName } = useSelector(({ context }) => context.currentCommunity);
  const currentUser = useSelector(({ context }) => context.currentUser);
  const { currentFilter, isLoading } = useSelector(({ pages }) => pages.communityMembers);

  const isA = useBranch() !== 'B';
  const isDesktop = useMediaQuery('overScreenSmall');

  const handleFilterClick = (newFilter) => {
    let filterName = newFilter;
    if (newFilter === 'roles') filterName = 'admins and moderators';
    if (newFilter === 'similar-to-me') filterName = 'similar to me';
    redirectToMembersPage(communitySlug, newFilter);
    trackFootfallEvent(Event.CLICKED, {
      clickType: 'community-members-filter',
      clickMetadata: { section: Section.CommunityMembers, element: filterName },
    });
  };

  return (
    <>
      {(isA || isDesktop) && (
        <SearchBarContainer>
          <SearchBar
            autoFocus={true}
            disableAutosuggest={true}
            isCommunitySearch={true}
            placeholder={i18n.t('Search members on ') + communityName}
            searchType="members"
          />
        </SearchBarContainer>
      )}

      <Filters>
        <p>{i18n.t('Sort members by')}:</p>
        <PostFilterInline
          options={membersFilterOptions}
          selected={currentFilter}
          onFilterClick={handleFilterClick}
        />
      </Filters>

      {!currentUser
        ? <PrivatePageErrorMessage />
        : isLoading
          ? <CommunityCardLoader height={245} />
          : <MembersList />
      }
    </>
  );
}


const SearchBarContainer = styled.div`
  width: calc(60% + 12px);
  @media (${({ theme }) => theme.underScreenSmall}) {
    width: 100%;
  }
  .search-bar {
    margin-bottom: 25px;
  }
  .search-bar__container {
    max-width: none;
  }
`;

const Filters = styled.div`
  margin-bottom: 20px;
  & > p {
    ${titleSmall};
    margin-bottom: 8px;
  }
`;
